import { render } from "./PAgencyCall.vue?vue&type=template&id=d79312be"
import script from "./PAgencyCall.vue?vue&type=script&lang=js"
export * from "./PAgencyCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__